import { createApiSlice } from 'app/createApiSlice'
import {
  API_FINDORA_GROUP_MAPPING,
  API_FINDORA_INVENTORY_LIST,
  API_FINDORA_RESULT_INVENTORY_LIST,
} from 'utils/apiList'

export const productMappingSchemaListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'productMappingSchemaList/api',
  endpoints(builder) {
    return {
      fetchFindoraInventoryList: builder.query({
        query({ itemIds }) {
          return {
            url: `/${API_FINDORA_INVENTORY_LIST}`,
            params: {
              itemIds,
            },
          }
        },
      }),
      fetchFindoraResultInventoryList: builder.query({
        query({
          page = 0,
          size = 9999,
          sortby = 'createdAt',
          sortdir = 'DESC',
          s,
          ...rest
        }) {
          return {
            url: `/${API_FINDORA_RESULT_INVENTORY_LIST}`,
            params: {
              page,
              size,
              sortby,
              sortdir,
              s,
              ...rest,
            },
          }
        },
      }),
      addInventory: builder.mutation({
        query(payload) {
          return {
            url: API_FINDORA_RESULT_INVENTORY_LIST,
            method: 'POST',
            body: payload,
          }
        },
      }),
      fetchGroupMapping: builder.query({
        query({ workresultIds }) {
          return {
            url: `/${API_FINDORA_GROUP_MAPPING}`,
            params: workresultIds
              ? { workresultIds: JSON.stringify(workresultIds) }
              : {},
          }
        },
      }),
      addGroupInventory: builder.mutation({
        query(payload) {
          return {
            url: API_FINDORA_GROUP_MAPPING,
            method: 'POST',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchFindoraInventoryListQuery,
  useLazyFetchFindoraInventoryListQuery,
  useFetchFindoraResultInventoryListQuery,
  useLazyFetchFindoraResultInventoryListQuery,
  useAddInventoryMutation,
  useFetchGroupMappingQuery,
  useLazyFetchGroupMappingQuery,
  useAddGroupInventoryMutation,
} = productMappingSchemaListApiSlice
